export const STORAGE = {
  filters: 'filtersHistory',
  theme: 'theme',
};
